import React from 'react'

import PlacesAutocomplete from 'react-places-autocomplete'

import {
    InputField,
    DropDownSection 
} from '../../Styles/Components/ApplicationSectionStyles'

class LocationSearchInput extends React.Component {
    constructor(props) {
        super(props)
        this.state = {value: this.props.value}
        this.value = this.props.value
    }

    onChange = value => {
        this.setState({ value })
        this.props.onChange('')
    }

    onSelect = value => {
        this.setState({ value })
        this.props.onChange(value)
    }

    render() {
        const searchOptions = {
            types: ['(regions)']
        }

        return (
            <PlacesAutocomplete
                value={this.state.value}
                onChange={this.onChange}
                onSelect={this.onSelect}
                searchOptions={searchOptions}
            >
                {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                    <div>
                        <InputField
                            {...getInputProps({
                                placeholder: 'Enter Location',
                                className: 'location-search-input',
                            })}
                        />
                        <DropDownSection className="autocomplete-dropdown-container">
                            {loading && <div style={{'font-size': '1.2rem'}}>Loading...</div>}
                            {suggestions.map(suggestion => {
                                const className = suggestion.active ? 'suggestion-item--active' : 'suggestion-item';
                                const style = suggestion.active ? { backgroundColor: '#E8E8E8', cursor: 'pointer', 'font-size': '1.6rem' } : { backgroundColor: 'transparent', cursor: 'pointer', 'font-size': '1.6rem' }
                                return (
                                    <div
                                        {...getSuggestionItemProps(suggestion, {
                                            className,
                                            style,
                                        })}
                                    >
                                        <span>{suggestion.description}</span>
                                    </div>
                                );
                            })}
                        </DropDownSection>
                    </div>
                )}
            </PlacesAutocomplete>
        )
    }
}

export default LocationSearchInput
